import React from "react";
import { SectionHeading } from "../SectionHeading";
import { CTAButton } from "../CTAButton";
import { painPoints } from "../../data/sections";
export function PainPointsSection() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-232" data-mp="1ble5ycpgo8un">
      <SectionHeading title="Do any of these sound familiar?" subtitle="If you answer YES to any of these, I created this system for you." data-id="element-233" data-mp="1bnz8l3xl2stg" />

      <ul className="mx-auto mt-12 grid max-w-5xl gap-x-10 gap-y-7 md:grid-cols-2" data-id="element-234" data-mp="jvrsc4lzpifl">
        {painPoints.map(({
        icon: Icon,
        text
      }) => <li key={text} className="flex gap-4" data-id="element-235" data-mp="nyeeppzw6b5e">
            <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-coral-light text-coral" data-id="element-236" data-mp="sv510v2ai2z9">
              <Icon className="h-6 w-6" aria-hidden="true" data-id="element-237" data-mp="xvaos05fv5c2" />
            </span>
            <p className="pt-1 text-[17px] leading-relaxed text-ink/85" data-id="element-238" data-mp="24bcywj6s0q4l">{text}</p>
          </li>)}
      </ul>

      <div className="mx-auto mt-14 max-w-3xl rounded-3xl bg-brand-light px-6 py-8 text-center sm:px-10" data-id="element-239" data-mp="298d4kszprqv6">
        <p className="font-serif text-2xl font-bold text-ink sm:text-3xl" data-id="element-240" data-mp="2r1q2ddcntwkg">And it doesn't have to be this way.</p>
        <p className="mt-4 text-lg leading-relaxed text-ink/80" data-id="element-241" data-mp="2n27k6pc83zlb">
          Because the problem isn't always that you need more information. Sometimes, what you really need is{" "}
          <strong className="text-brand" data-id="element-242" data-mp="2d2gquqzefqmt">a system for using the information you already have.</strong>
        </p>
        <p className="mt-4 text-lg text-ink/80" data-id="element-243" data-mp="285qdibezb953">That's why I created Reflexology Session Blueprint™.</p>
      </div>

      <CTAButton label="Yes! I want a system for organizing my practice" className="mt-10" data-id="element-244" data-mp="23bccnthjs9t1" />
    </section>;
}